<template>
<span v-if="value === 'true'">
    <slot/>
</span>
</template>

<script>
export default {
    props: ['value'],
};
</script>
